export default __webpack_public_path__ + "static/media/DamacaiZodiacPig.fbd25da6.png";